import { useLogger } from "@sb1finans/components/dist/SB1Logger";
import { useEffect, useState } from "react";
import { useAccount } from "../state/AppDataStateProvider";
import { useCurrentAgreementId } from "../utils/route-hooks";
import { Invoice } from "@sb1finans/banking-api/dist/api";
import { accountsApi } from "../api";
import { Alert, Container, Stack, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";

const AccountTerminationPage = () => {

    const agreementId = useCurrentAgreementId()
    const account = useAccount()
    const [terminationInvoice, setTerminationInvoice] = useState<Invoice | null>(null)
    const [isLoading, setIsLoading] = useState(false)

    const logger = useLogger()

    const onRequestTermination = async () => {
        logger.info("Requesting account termination")
        setIsLoading(true)
        try {
            const response  =  await accountsApi.requestAccountTermination(agreementId, account?.id ?? "")
            if (response.status === 200) {
            logger.info("Account termination requested successfully")
            setTerminationInvoice(response.data)
        } else {
            logger.error("Failed to request account termination", response)
        }
        } catch (error) {
            logger.error("Error requesting account termination", error)
        } finally {
            setIsLoading(false)
        }
    }

     useEffect(() => {
        logger.info("Account Termination Page loaded")
    }, [logger])

    return (
        <Container maxWidth="md">
            <Stack spacing={2}>
                <Typography variant="h4" gutterBottom>Innfri lån</Typography>
                {terminationInvoice ? (
                    <div>
                        <Alert severity="info" sx={{ mb: 2 }}>Forespørsel om innfrielse mottatt</Alert>
                        <Typography variant="body1" sx={{marginBottom: "16px"}} gutterBottom>Vi har mottatt din forespørsel om innfrielse av lånet. Vennligst betal utestående beløp så fort som mulig og senest innen 3 dager. Se betalingsinformasjonen nedenfor.</Typography>
                        <Typography variant="h5" gutterBottom>Fakturadetaljer</Typography>
                        <Typography variant="body1" gutterBottom>Fakturanummer: {terminationInvoice?.invoiceNo}</Typography>
                        <Typography variant="body1" gutterBottom>Beløp: {terminationInvoice?.totalAmount}</Typography>
                        <Typography variant="body1" gutterBottom>KID: {terminationInvoice?.cid}</Typography>
                        <Typography variant="body1" gutterBottom>Konto: 4201 07 00064</Typography>
                    </div>
                ) : (
                    <>
                        <Typography variant="body1" gutterBottom>Ved å trykke på knappen bekrefter du at du ønsker å innfri ditt lån hos oss. Innfrielsesbeløpet må betales innen 3 dager fra dagens dato.</Typography>    
                        <LoadingButton variant="contained" color="error" loading={isLoading} onClick={onRequestTermination}>Innfri lån</LoadingButton>
                    </>
                )}
                
            </Stack>
        </Container>
    );
}

export default AccountTerminationPage;